// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3cTdy","modalFooterButton":"ModalNotes_modalFooterButton__kZRvq"};